import {
    SET_SCROLL_PROGRESS,
    SET_SCROLL_HEIGHT,
    SET_GUIDE_TITLE,
    SET_TOC_VISIBILITY,
    SET_FORM_SENT,
    SET_WINDOW_WIDTH,
    SET_WINDOW_HEIGHT,
} from "./actionTypes";
import localStorage from '../util/localStorage';

export const setScrollProgress = () => {
    const h = document.documentElement,
        b = document.body,
        st = 'scrollTop',
        sh = 'scrollHeight';

    const percent = (h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight) * 100;

    return {
        type: SET_SCROLL_PROGRESS,
        payload: percent
    };
};

export const setScrollHeight = () => {
    const h = document.documentElement,
        b = document.body,
        sh = 'scrollHeight';
    return {
        type: SET_SCROLL_HEIGHT,
        payload: ((h[sh] || b[sh]) - h.clientHeight)
    };
};

export const setGuideTitle = title => ({
    type: SET_GUIDE_TITLE,
    payload: title
});

export const setTocVisibility = isVisible => ({
    type: SET_TOC_VISIBILITY,
    payload: isVisible
});

export const setFormSent = isSent => {
    // todo move this async actions to middleware like redux-saga or redux-thunk
    if (isSent === true) {
        localStorage.setItem('formSent', true);
    } else {
        localStorage.removeItem('formSent');
    }
    return {
        type: SET_FORM_SENT,
        payload: isSent
    }
};

export const setWindowWidth = (width = null) => ({
    type: SET_WINDOW_WIDTH,
    payload: width
});

export const setWindowHeight = (height = null) => ({
    type: SET_WINDOW_HEIGHT,
    payload: height
});